import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-5 gap-2 overflow-x-auto" }
const _hoisted_2 = { class: "flex justify-start items-center h-full p-2 border-b border-next-light-gray" }
const _hoisted_3 = { class: "flex justify-start items-center h-full p-2 border-b border-next-light-gray" }
const _hoisted_4 = { class: "text-sm whitespace-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Card, (c, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "bg-white grid grid-cols-1 items-center min-w-fit text-sm",
        key: i
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("b", null, _toDisplayString(c.title), 1),
          _createTextVNode(" : " + _toDisplayString(c.valore), 1)
        ])
      ]))
    }), 128)),
    _createElementVNode("div", {
      class: "bg-white grid grid-cols-1 items-center min-w-fit text-sm",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clickFee')))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("b", null, "Fee", -1)),
        _cache[2] || (_cache[2] = _createTextVNode(" : ")),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.fee) + " €", 1)
      ])
    ])
  ]))
}